import React, { useState, useEffect } from "react";
import { useAccount, useBalance } from "wagmi";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import {
  POTION_DAO_ZAP_ADDRESS,
  UNISWAP_ROUTER_ADDRESS,
  NEW_ZAP_ADDRESS,
  ANDY_ZAPPER,
  WETH_TOKEN_ADDRESS,
  UNISWAP_FACTORY_ADDRESS,
  ANDY,
  ANDY_BNB_ORACLE,
  V3_QUOTER_ADDRESS,
} from "../../../Config/index";
import POTION_DAO_ZAP_ABI from "../../../Config/POTION_DAO_ZAP_ABI.json";
import IUniswapv2Pair from "../../../Config/IUniswapv2Pair.json";
import UniswapRouter from "../../../Config/UniswapRouter.json";
import NEW_ZAP_ABI from "../../../Config/NEW_ZAP_ABI.json";
import IUniswapV2Factory from "../../../Config/UniswapFactory.json";
import IUniswapOracleV3 from "../../../Config/IUniswapOracleV3.json";
import V3_QUOTER_ABI from "../../../Config/QuoterV2.json";

import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Divider,
  TextField,
} from "@mui/material";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ApproveButton from "../../common/ApproveButton";
import convertEtherToWei from "../../../Utils/convertEtherToWei";
import useCustomContractWrite from "../../../Hooks/useCustomContractWrite";
import Loader from "../../Loader/Loader";
import calculateSwapInAmount from "../../../Utils/calculateSwapInAmount";
import useCustomContractRead from "../../../Hooks/useCustomContractRead";
import convertWeiToEther from "../../../Utils/convertWeiToEther";
import useCalculateLiquidity from "../../../Hooks/useCalculateLiquidity";
import BigNumber from "bignumber.js";
import { ethers } from "ethers";
import useCheckAllowance from "../../../Hooks/useCheckAllowance";
import style from "./farm.module.css";

const Pools_Name = [
  "BNBX / BNB",
  "SHLD / BNB",
  "SHLD / GUARD",
  "GUARDX / GUARD",
  "BNBX / GUARDX",
  "ANDY / ANDYX",
];

export const ZapModal = ({
  poolIndex,
  token0Info,
  token1Info,
  lpToken,
  handleClose,
  index,
  getApr,
  perDay,
  token0Image,
  token1Image,
}) => {
  const { address, isConnected } = useAccount();
  const [SlippageInPercent, setSlippageInPercent] = useState(0.5);
  const { openConnectModal } = useConnectModal();
  const [isAproveERC20, setIsApprovedERC20] = useState(true);
  const [inputZapValue, setInputZapValue] = useState("");
  const [estimateAlien, setEstimateAlien] = useState("");
  const [minLiquidityReceived, setMinLiquidityReceived] = useState("0");

  const isNewZapperPool = poolIndex === 3 || poolIndex === 4 || poolIndex === 5; // Pools 3-4 use new zapper
  const isV3ZapperPool = poolIndex === 5;
  const isNonNativePool = !!(
    token0Info.address !== WETH_TOKEN_ADDRESS && token1Info.address
  );

  const handleInputZapChange = (event) => {
    const { value } = event.target;
    const isStack = /^[0-9]*(\.[0-9]{0,9})?$/.test(value);
    if (isStack) {
      setInputZapValue(value);
    }
  };

  const POOLS_IMAGE = [
    { token0: "/icons/bnb.png", token1: "/icons/bnb.png" },
    { token0: "/icons/bnb.png", token1: "/icons/logo.svg" },
    {},
    { token0: "/icons/guard.png", token1: "/icons/guard.png" },
    {},
    { token0: "/icons/andy.png", token1: "/icons/andy.png" },
  ];

  const { data: checkAllowance } = useCheckAllowance({
    tokenAddress: token0Info?.address,
    spenderAddress: POTION_DAO_ZAP_ADDRESS,
    isLpToken: false,
  });

  useEffect(() => {
    if (checkAllowance && address) {
      const price = parseFloat?.(inputZapValue === "" ? "1" : inputZapValue);
      const allowance = parseFloat?.(convertWeiToEther?.(checkAllowance));
      // //console.log(allowance >= price);
      if (allowance >= price) {
        setIsApprovedERC20(true);
      } else {
        // setIsApprovedERC20(false);
      }
    }
  }, [checkAllowance, address, inputZapValue]);

  // const { data: alienBalance } = useBalance({
  //     address: address,
  //     token: token0Info?.address,
  //     enabled: address !== undefined && token0Info?.address !== undefined,
  // });

  const { data: alienBalance } = useBalance({
    address: address,
    // token: WETH_TOKEN_ADDRESS,
    watch: true,
    enabled: address !== undefined,
  });

  const setMax = (value) => {
    // alert(value)
    const isStack = /^[0-9]*(\.[0-9]{0,18})?$/.test(value);
    if (isStack) {
      setInputZapValue(value);
    }
  };

  const { data: totalSupply } = useCustomContractRead({
    Adrress: lpToken,
    Abi: IUniswapv2Pair,
    FuncName: "totalSupply",
  });

  const { data: reserves } = useCustomContractRead({
    Adrress: lpToken,
    Abi: IUniswapv2Pair,
    FuncName: "getReserves",
    isEnabled: inputZapValue !== "",
    onSuccess: (data) => {
      // //console.log(data?.[0].toString());
      const minati = convertWeiToEther?.(
        parseInt?.(
          calculateSwapInAmount?.(
            data?.[0]?.toString(),
            convertEtherToWei?.(
              inputZapValue === "" ? "0" : inputZapValue
            ).toString()
          )
        ).toString()
      );
      setEstimateAlien?.(
        parseFloat?.(inputZapValue === "" ? "0" : inputZapValue) -
          parseFloat?.(minati)
      );
    },
  });

  const { data: andyEstimate } = useCustomContractRead({
    Adrress: ANDY_BNB_ORACLE,
    Abi: IUniswapOracleV3,
    FuncName: "quote",
    Args: [WETH_TOKEN_ADDRESS, convertEtherToWei(inputZapValue), ANDY],
  });

  const { data: andyxEstimate } = useCustomContractRead({
    Adrress: UNISWAP_ROUTER_ADDRESS,
    Abi: UniswapRouter,
    FuncName: "getAmountsOut",
    Args: [
      "1000000000000000000",
      [token0Info.address, token1Info.address], // ANDY→ANDYX
    ],
    // enabled: isV3ZapperPool && Boolean(andyEstimate),
  });

  //  const { data: quoter2 } = useCustomContractRead({
  //   Adrress: V3_QUOTER_ADDRESS,
  //   Abi: V3_QUOTER_ABI,
  //   FuncName: "quoteExactInputSingle",
  //   Args: [{
  //   tokenIn: WETH_TOKEN_ADDRESS, // WETH
  //   tokenOut: ANDY, // ANDY
  //   amountIn: "1000000000000000000", // 1 ETH in wei
  //   fee: 2500,
  //   sqrtPriceLimitX96: 0
  // }],
  // });

  // console.log(andyxEstimate, "quoter");

  const {
    executeWrite: zapContractWrite,
    isLoading: isLoadingZapp,
    isSuccess: isSuccessZapp,
    isError: isErrorZapp,
    error: errorZapp,
    txHash: zapWaitForTransaction,
  } = useCustomContractWrite({
    address: isNewZapperPool
      ? (isV3ZapperPool
        ? ANDY_ZAPPER
        : NEW_ZAP_ADDRESS)
      : POTION_DAO_ZAP_ADDRESS,
    abi: isNewZapperPool ? NEW_ZAP_ABI : POTION_DAO_ZAP_ABI,
    functionName: "zapETH",
    args: isNewZapperPool
      ? [poolIndex, minLiquidityReceived, true]
      : [
          poolIndex,
          minLiquidityReceived,
          convertEtherToWei(inputZapValue === "" ? "0" : inputZapValue),
          true,
        ],
    value: convertEtherToWei(inputZapValue === "" ? "0" : inputZapValue),
    isEnabled:
      parseFloat?.(inputZapValue === "" ? "0" : inputZapValue) > 0 &&
      parseFloat?.(inputZapValue === "" ? "0" : inputZapValue) <=
        parseFloat?.(alienBalance?.formatted) &&
      address !== undefined &&
      isAproveERC20,
  });

  useEffect(() => {
    if (isSuccessZapp) {
      handleClose();
    }
  }, [zapWaitForTransaction, isSuccessZapp]);

  useEffect(() => {
    if (reserves) {
      // console.log("reseves", reserves);

      const minati = convertWeiToEther?.(
        parseInt?.(
          calculateSwapInAmount?.(
            reserves?.[0]?.toString(),
            convertEtherToWei?.(
              inputZapValue === "" ? "0" : inputZapValue
            ).toString()
          )
        ).toString()
      );
      // console.log("minati", minati);

      setEstimateAlien?.(
        parseFloat?.(inputZapValue === "" ? "0" : inputZapValue) -
          parseFloat?.(minati)
      );
    }
  }, [reserves, inputZapValue]);

  // const { data: routerAddress } = useCustomContractRead({
  //   Adrress: POTION_DAO_ZAP_ADDRESS,
  //   Abi: POTION_DAO_ZAP_ABI,
  //   FuncName: "uniRouter",
  //   onSuccess: (data) => {
  //     // //console.log(data?.[0].toString());
  //   }
  // })

  const { data: getAmountOutFoMinati } = useCustomContractRead({
    Adrress: UNISWAP_ROUTER_ADDRESS,
    Abi: UniswapRouter,
    FuncName: "getAmountOut",
    isEnabled: inputZapValue !== "" && estimateAlien !== "",
    Args: [
      convertEtherToWei?.(
        parseFloat?.(
          parseFloat?.(inputZapValue === "" ? "0" : inputZapValue) -
            parseFloat?.(estimateAlien === "" ? "0" : estimateAlien)
        ).toString()
      ),
      reserves?.[0],
      reserves?.[1],
    ],
    onSuccess: (data) => {},
  });

  function calculateMinimumLiquidity(
    inputAmount,
    totalSupply,
    reserve0,
    SlippageInPercent
  ) {
    const input = new BigNumber(convertEtherToWei?.(inputAmount)?.toString());
    const reserve0BigNumber = new BigNumber(
      reserve0 !== NaN ? reserve0?.toString() : "0" || 0
    );
    const totalSupplyBigNumber = new BigNumber(totalSupply?.toString() || 0);
    const slippageBigNumber = new BigNumber(
      SlippageInPercent?.toString() || 0
    ).div(100);

    const minLiquidity = input
      .times(totalSupplyBigNumber)
      .times(new BigNumber(1).minus(slippageBigNumber))
      .div(reserve0BigNumber.times(2));

    // console.log("minLiquidity", minLiquidity.toString());

    // //console.log(parseInt?.(!minLiquidity.isNaN()?minLiquidity:"0")?.toString());
    return parseInt?.(!minLiquidity.isNaN() ? minLiquidity : "0")?.toString();
  }
  // console.log("calculateMinimumLiquidity", calculateMinimumLiquidity());

  const calculatePriceImpact = (amount0, amount1, reserves) => {
    const reserve0 = Number(reserves?.[0]);
    const reserve1 = Number(reserves?.[1]);
    const midPrice = reserve0 / reserve1;

    const midPriceAfter =
      (parseFloat?.(reserve0) + parseFloat?.(amount0)) /
      (parseFloat?.(reserve1) + parseFloat?.(amount1));
    const priceImpact = Math.abs(midPrice - midPriceAfter) / midPrice;
    return (priceImpact * 100)?.toFixed(3);
  };
  const closeModal = (e) => {
    if (e.target.classList.contains("outterdiv")) {
      handleClose();
    }
  };

  // Get pair addresses for swap paths
  const { data: directPair0 } = useCustomContractRead({
    Adrress: UNISWAP_FACTORY_ADDRESS,
    Abi: IUniswapV2Factory,
    FuncName: "getPair",
    Args: [WETH_TOKEN_ADDRESS, token0Info?.address],
    isEnabled: isNonNativePool && !!token0Info?.address,
  });

  const { data: directPair1 } = useCustomContractRead({
    Adrress: UNISWAP_FACTORY_ADDRESS,
    Abi: IUniswapV2Factory,
    FuncName: "getPair",
    Args: [WETH_TOKEN_ADDRESS, token1Info?.address],
    isEnabled: isNonNativePool && !!token1Info?.address,
  });

  const { data: token0Estimate } = useCustomContractRead({
    Adrress: UNISWAP_ROUTER_ADDRESS,
    Abi: UniswapRouter,
    FuncName: "getAmountsOut",
    Args: [
      convertEtherToWei(inputZapValue === "" ? "0" : inputZapValue)
        .div(2)
        .toString(),
      [WETH_TOKEN_ADDRESS, token0Info?.address],
    ],
    isEnabled: !isNonNativePool && !!inputZapValue,
  });

  const { data: intertoken0Estimate } = useCustomContractRead({
    Adrress: UNISWAP_ROUTER_ADDRESS,
    Abi: UniswapRouter,
    FuncName: "getAmountsOut",
    Args: [
      convertEtherToWei(inputZapValue === "" ? "0" : inputZapValue)
        .div(2)
        .toString(),
      [WETH_TOKEN_ADDRESS, token0Info?.address, token0Info?.address],
    ],
    isEnabled: !isNonNativePool && !!inputZapValue,
  });

  const { data: token1Estimate } = useCustomContractRead({
    Adrress: UNISWAP_ROUTER_ADDRESS,
    Abi: UniswapRouter,
    FuncName: "getAmountsOut",
    Args: [
      convertEtherToWei(inputZapValue === "" ? "0" : inputZapValue)
        .div(2)
        .toString(),
      [WETH_TOKEN_ADDRESS, token1Info?.address],
    ],
    isEnabled: !isNonNativePool && !!inputZapValue,
  });

  const { data: intertoken1Estimate } = useCustomContractRead({
    Adrress: UNISWAP_ROUTER_ADDRESS,
    Abi: UniswapRouter,
    FuncName: "getAmountsOut",
    Args: [
      convertEtherToWei(inputZapValue === "" ? "0" : inputZapValue)
        .div(2)
        .toString(),
      [WETH_TOKEN_ADDRESS, token0Info?.address, token1Info?.address],
    ],
    isEnabled: !isNonNativePool && !!inputZapValue,
  });

  const [estimatedToken0Amount, setEstimatedToken0Amount] = useState(0);
  const [estimatedToken1Amount, setEstimatedToken1Amount] = useState(0);

  //    console.log("getAmountOutFoMinati", getAmountOutFoMinati);

  useEffect(() => {
    if (isNonNativePool) {
      if (isV3ZapperPool) {
        if (andyEstimate) {
          setEstimatedToken0Amount(
            new BigNumber(andyEstimate).div(2).toFixed(0)
          );
        }
        if (andyxEstimate && andyEstimate) {
          setEstimatedToken1Amount(new BigNumber(andyEstimate).div(2).times(andyxEstimate[1]).div(1e18).toFixed(0))
        }
      } else {
        if (token0Estimate) {
          setEstimatedToken0Amount(token0Estimate?.[1]);
        }
        if (!token0Estimate && intertoken0Estimate) {
          setEstimatedToken0Amount(intertoken0Estimate?.[2]);
        }
        if (token1Estimate) {
          setEstimatedToken1Amount(token1Estimate?.[1]);
        }
        if (!token1Estimate && intertoken1Estimate) {
          setEstimatedToken1Amount(intertoken1Estimate?.[2]);
        }
      }
    } else {
      if (estimateAlien) {
        setEstimatedToken0Amount(
          convertEtherToWei(estimateAlien?.toString())?.toBigInt()
        );
      }
      setEstimatedToken1Amount(getAmountOutFoMinati);
    }
  }, [
    isNonNativePool,
    getAmountOutFoMinati,
    estimateAlien,
    token0Estimate,
    token1Estimate,
    intertoken0Estimate,
    intertoken1Estimate,
    isV3ZapperPool,
    andyEstimate,
    andyxEstimate
  ]);
  

  // Add this useEffect to calculate liquidity when amounts change
  useEffect(() => {
    if (!totalSupply || !reserves) return;

    if (!isNonNativePool) {
      // Existing native pair calculation
      const liquidity = calculateMinimumLiquidity(
        inputZapValue || "0",
        totalSupply,
        reserves[0],
        SlippageInPercent
      );
      setMinLiquidityReceived(liquidity);
    } else {
      // New calculation for non-native pairs
      if (
        estimatedToken0Amount &&
        estimatedToken1Amount &&
        reserves[0] &&
        reserves[1]
      ) {
        const amount0 = estimatedToken0Amount;
        const amount1 = estimatedToken1Amount;
        const reserve0 = new BigNumber(reserves[0]);
        const reserve1 = new BigNumber(reserves[1]);

        const slippageBigNumber = new BigNumber(
          SlippageInPercent?.toString() || 0
        ).div(100);

        // console.log("amount0",amount0, amount1, reserve0, reserve1);

        // Liquidity = min(amount0/reserve0, amount1/reserve1) * totalSupply
        const ratio0 = new BigNumber(amount0).times(totalSupply).div(reserve0);
        const ratio1 = new BigNumber(amount1).times(totalSupply).div(reserve1);

        // console.log("ratio0", ratio0.toString(), ratio1.toString());

        const minRatio = BigNumber.min(ratio0, ratio1);

        // Apply slippage tolerance
        const minLiquidity = minRatio
          .times(new BigNumber(1).minus(slippageBigNumber))
          // .div(100)
          .toFixed(0);

        const liquidity = (
          minLiquidity ? minLiquidity : "0"
        ).toString();

        console.log("minLiquidity", liquidity);

        // console.log("liquidity", liquidity);
        setMinLiquidityReceived(liquidity);
      }
    }
  }, [
    estimatedToken0Amount,
    estimatedToken1Amount,
    reserves,
    totalSupply,
    inputZapValue,
    SlippageInPercent,
    isNonNativePool,
  ]);

  // console.log(
  //   estimatedToken0Amount,
  //   estimatedToken1Amount,
  //   "estimatedToken0Amount"
  // );

  return (
    <div
      className={
        style.zapModal +
        " d-flex justify-content-center align-items-xl-center outterdiv"
      }
      onClick={closeModal}
    >
      <div className={style.center_card}>
        <h1 className="text-center">Zap into Farms</h1>
        <div className={style.row1}>
          <div>
            <div className={style.input_div + " d-flex gap-4"}>
              <div className="d-flex gap-3 align-items-center">
                <img src="/icons/bnb.png" className={style.imgbg} alt="" />
                <p className="text-uppercase opacity-50 mb-0">BNB</p>
              </div>
              <input
                type="number"
                className="flex-grow-1"
                placeholder="0.00"
                autoComplete="off"
                value={inputZapValue}
                onChange={handleInputZapChange}
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                }}
              />
            </div>
          </div>
          <div className="d-flex justify-content-between mt-3">
            <button
              onClick={() =>
                setMax(
                  alienBalance?.formatted
                    ? parseFloat?.(alienBalance?.formatted)?.toFixed(18)
                    : "0.00"
                )
              }
              className="border-0 bg-transparent fw-semibold"
              style={{
                fontFamily: "var(--font-pop),",
                color: "var(--main-color)",
              }}
            >
              Max
            </button>
            <p className="mb-0">
              <span className="opacity-50">Balance </span>
              {alienBalance?.formatted
                ? parseFloat?.(alienBalance?.formatted).toFixed(9)
                : "0.0"}
            </p>
          </div>
        </div>
        <div className={style.row2 + " d-flex my-3 justify-content-center"}>
          <div className="d-flex justify-content-center align-items-center">
            <img src="/icons/arrow-down.png" width="100%" alt="" />
          </div>
        </div>
        <div className={style.row3}>
          <div className="d-inline-flex align-items-center gap-2">
            <div>
              <img
                src={POOLS_IMAGE[poolIndex].token0}
                alt=""
                className={style.imgbg}
              />
              <img
                src={POOLS_IMAGE[poolIndex].token0}
                alt=""
                className={style.imgbg}
              />
            </div>
            <p className="mb-0">{Pools_Name[poolIndex]}</p>
          </div>
          <p className="my-3">Est. Allocation</p>
          <div>
            <div className="d-flex justify-content-between align-items-center my-2">
              <div className="d-flex align-items-center gap-2">
                <img
                  src={POOLS_IMAGE[poolIndex].token1}
                  alt=""
                  className={style.imgbg}
                />
                <p className="mb-0">{token1Info?.symbol}</p>
              </div>
              <p className="mb-0 fs-6">
                {inputZapValue === "" || !estimatedToken1Amount
                  ? "0.000"
                  : parseFloat?.(
                      convertWeiToEther?.(estimatedToken1Amount?.toString())
                    ).toFixed(5)}
              </p>
            </div>
            <div className="d-flex justify-content-between align-items-center my-2">
              <div className="d-flex align-items-center gap-2">
                <img
                  src={POOLS_IMAGE[poolIndex].token0}
                  className={style.imgbg}
                  alt=""
                />
                <p className="mb-0">{token0Info?.symbol}</p>
              </div>
              <p className="mb-0 fs-6">
                {inputZapValue === "" || !estimatedToken0Amount
                  ? "0.000"
                  : parseFloat?.(
                      convertWeiToEther?.(estimatedToken0Amount?.toString())
                    ).toFixed(5)}
              </p>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div>
              <span>APR</span>
              <p>{parseFloat(getApr).toFixed(2)}%</p>
            </div>
            <div>
              <span>Est.Daily Income</span>
              <p>${parseFloat(perDay * (inputZapValue / 100)).toFixed(2)}</p>
            </div>
            <div>
              <span>Price Impact</span>
              <p>
                {calculatePriceImpact?.(
                  convertEtherToWei?.(
                    inputZapValue === "" ? "0" : inputZapValue
                  ),
                  getAmountOutFoMinati,
                  reserves
                ) > 0
                  ? calculatePriceImpact?.(
                      convertEtherToWei?.(
                        inputZapValue === "" ? "0" : inputZapValue
                      ),
                      getAmountOutFoMinati,
                      reserves
                    )
                  : "0.0"}
                %
              </p>
            </div>
          </div>
        </div>
        <div className={style.row4 + " my-3"}>
          <div className="d-flex my-2 justify-content-between">
            <span>Minimum Received</span>
            <p className="mb-0">
              {parseFloat?.(convertWeiToEther?.(minLiquidityReceived)).toFixed(
                7
              )}{" "}
              {Pools_Name[poolIndex]} LP
            </p>
          </div>
          <div className="d-flex my-2 justify-content-between">
            <span>Slippage</span>
            <div className="d-flex gap-2">
              <button
                className={"btn2"}
                onClick={() => {
                  setSlippageInPercent(0.5);
                }}
              >
                0.5%
              </button>
              <button
                className={"btn2"}
                onClick={() => {
                  setSlippageInPercent(1);
                }}
              >
                1%
              </button>
              <button
                className={"btn2"}
                onClick={() => {
                  setSlippageInPercent(2);
                }}
              >
                2%
              </button>
              <input
                className="btn2"
                value={SlippageInPercent + "%"}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9.]/g, "");
                  setSlippageInPercent(numericValue);
                }}
              />
            </div>
          </div>
        </div>
        {/* <button className='btn1 py-3 w-100' >Connect Wallet</button> */}
        {address && isConnected ? (
          <>
            {!isAproveERC20 ? (
              <div>
                <ApproveButton
                  tokenAddress={token0Info?.address}
                  spenderAddress={POTION_DAO_ZAP_ADDRESS}
                  setIsApprovedERC20={setIsApprovedERC20}
                  isLpToken={false}
                  color={"white"}
                />
              </div>
            ) : parseFloat?.(inputZapValue) >
              parseFloat?.(alienBalance?.formatted) ? (
              <div>
                <button className="btn1 py-3 w-100">Insufficient Fund</button>
              </div>
            ) : // Price impact too high
            calculatePriceImpact?.(
                convertEtherToWei?.(inputZapValue === "" ? "0" : inputZapValue),
                getAmountOutFoMinati,
                reserves
              ) > SlippageInPercent ? (
              <div>
                <button className="btn1 py-3 w-100">
                  Price impact too high
                </button>
              </div>
            ) : (
              <button
                disabled={
                  parseFloat?.(inputZapValue) > 0 && !isLoadingZapp
                    ? false
                    : true
                }
                onClick={async () => {
                  try {
                    await zapContractWrite();
                  } catch (error) {
                    //console.log(error);
                  }
                }}
                sx={{
                  gap: "6px",
                }}
                variant="contained"
                className="btn1 py-3 w-100"
                fullWidth
              >
                {isLoadingZapp && <Loader color="#423A2A" />}
                Zapp
              </button>
            )}
          </>
        ) : (
          <button
            onClick={openConnectModal}
            variant="contained"
            fullWidth
            className="btn1 py-3 w-100"
          >
            Connect Wallet
          </button>
        )}
      </div>
    </div>
  );
};
